export class UrlsUtils {

    static recognizingUrl(str) {
        let isValidUrl = false;
        let re = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/g;
        //let re = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/g;
        if((re.exec(str)) !== null){
            isValidUrl = true;
        }
        return isValidUrl;
    }

    static updateLinksInHTML(str, uri, link) {
        var re = /href="([^]+)/g;
        var m;
        var links = [];
        //console.log('test: ', re.exec(str));

        while ((m = re.exec(str)) !== null) {
            if (m.index === re.lastIndex) {
                re.lastIndex++;
            }
      
            links.push({
                match: m[0],   // the entire match
                href: m[1],    // the first parenthesis => (https?:\/\/.*)
                anchor: m[2],  // the second one => ([^<]*)
            });

        }
        return links;
    }

    static getHeadClassInHTML(str, uri, link) {
        //var re = /\mag_sponsor_head_spacer[^\s]*/g;
        var re = /(?:class|className)=(?:["']\W+\s*(?:\w+)\()?["']([^'"]+)['"]/g;
        var m;

        while ((m = re.exec(str)) !== null) {
            if (m.index === re.lastIndex) {
                re.lastIndex++;
            }
            //console.log('m: ', m); // The all substring
            if (m[1] === 'mag_sponsor_head_spacer') {
                return m;
            }
        }
        return "";

    }
}
